import { type ICouponRepository, type IDeleteCouponWalletUseCase } from '../../../domain/entry.js';

/**
 * Use case for deleting coupon wallet data in the store.
 *
 * @param couponRepository Coupon repository dependency
 * @returns Use case executor for deleting the coupon wallet
 */
export function deleteCouponWalletUseCase(couponRepository: ICouponRepository): IDeleteCouponWalletUseCase {
  return {
    execute: ({ couponId, couponIndex }): ReturnType<IDeleteCouponWalletUseCase['execute']> => {
      const isDeleted = couponRepository.deleteCouponWallet({ couponId, couponIndex });
      return isDeleted;
    },
  };
}
